module.exports = __webpack_public_path__ + "img/citys.465f2ca2.png";